import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import GeoService from '../port/adapter/GeoService';

class AddressSuggestion extends Component {
	constructor (props) {
		super(props);

		this.state = {
			query: props.query || '',
			inputQuery: props.query || '',
			isFocused: false,
			list: [],
			index: -1,
			isVisible: true
		}
	}

	onInputFocus = () => {
		this.setState({
			isFocused: true
		});

		const { list, query } = this.state;
		if (!list.length && query) {
			this.fetchSuggestions();
		}
	};

	onInputBlur = () => {
		this.setState({
			isFocused: false
		});

		const { list, query } = this.state;
		if (!list.length && query) {
			this.fetchSuggestions();
		}
	};

	onInputChange = e => {
		const value = e.target.value;
		this.setState({
			query: value,
			inputQuery: value,
			isVisible: true
		}, () => this.fetchSuggestions());
	};

	onKeyPress = e => {
		if (e.which == 40) {
			// Arrow down
			e.preventDefault();
			if (this.state.index < this.state.list.length) {
				const newIndex = this.state.index + 1;
				const newInputQuery = this.state.list[newIndex].value;
				this.setState({index: newIndex, query: newInputQuery})
			}
		} else if (e.which == 38) {
			// Arrow up
			e.preventDefault();
			if (this.state.index >= 0) {
				const newIndex = this.state.index - 1;
				const newInputQuery = newIndex == -1 ? this.state.inputQuery : this.state.list[newIndex].value;
				this.setState({index: newIndex, query: newInputQuery})
			}
		} else if (e.which == 13) {
			// Enter
			e.preventDefault();
			if (this.state.index >= 0) {
				this.selectSuggestion(this.state.index);
			}
		}
	};

	fetchSuggestions = () => {
		GeoService.getSuggestions(this.state.query)
			.subscribe(suggestionList => {
				if (suggestionList) {
					this.setState({
						list: suggestionList,
						index: -1
					});
				}
			});
	};

	onSuggestionClick = (index, e) => {
		e.stopPropagation();
		this.selectSuggestion(index);
	};

	selectSuggestion = index => {
		const { list } = this.state;
		const newValue = list[index].name;

		if (list.length >= index - 1) {
			this.setState({
				query: newValue,
				isVisible: false,
				inputQuery: newValue
			}, () => {
				this.fetchSuggestions();
				setTimeout(() => this.setCursorToEnd(this.textInput), 100);
			});

			if (this.props.onChange) {
				if (!list[index].data) {
					GeoService.getLocation(list[index].id)
					.subscribe(geoLocation => {
						if (geoLocation) {
							const itemData = {
								geo_id: geoLocation.id,
								address: geoLocation.name,
								geo_lat: geoLocation.latitude,
								geo_lon: geoLocation.longitude
							}
							
							list[index].data = itemData;
							this.props.onChange({...list[index], data: itemData});
						}
					});
				} else {
					this.props.onChange(list[index]);
				}
			}
		}
	};

	setCursorToEnd = (element) => {
		const valueLength = element.value.length;
		if (element.selectionStart || element.selectionStart == '0') {
			// Firefox/Chrome
			element.selectionStart = valueLength;
			element.selectionEnd = valueLength;
			element.focus();
		}
	};

	getHighlightWords = () => {
		const wordsToPass = ['г', 'респ', 'ул', 'р-н', 'село', 'деревня', 'поселок', 'пр-д', 'пл', 'к', 'кв', 'обл', 'д'];
		let words = this.state.inputQuery.replace(',', '').split(' ');
		words = words.filter((word) => {
			return wordsToPass.indexOf(word) < 0;
		});
		return words;
	};

	render () {
		const { placeholder } = this.props;
		const { isFocused, query, isVisible, list } = this.state;

		return (
			<div className="react-dadata react-dadata__container">
				<div>
					<input
						className="react-dadata__input"
						placeholder={placeholder || ''}
						value={query}
						ref={c => this.textInput = c}
						onChange={this.onInputChange}
						onKeyPress={this.onKeyPress}
						onKeyDown={this.onKeyPress}
						onFocus={this.onInputFocus}
						onBlur={this.onInputBlur}
					/>
				</div>
				{isFocused && isVisible && list.length > 0 ?
					<div className="react-dadata__suggestions">
						{list.map((suggestion, index) => <div key={suggestion.id}
							onMouseDown={this.onSuggestionClick.bind(this, index)}
							className={cn('react-dadata__suggestion', {'react-dadata__suggestion--current': index == this.state.index})} >
							{suggestion.name}
						</div>
						)}
					</div> : null
				}
			</div>
		);
	}
}

AddressSuggestion.propTypes = {
	query: PropTypes.string,
	placeholder: PropTypes.string,
	onChange: PropTypes.func
}

AddressSuggestion.defaultProps = {
	onChange: () => {}
}

export default AddressSuggestion;



// WEBPACK FOOTER //
// ./components/AddressSuggestion.js